import React from 'react'

const ClustersSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.53846" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4461_1532)" />
    <path
      d="M46.6231 42.7269C46.1014 42.7269 45.5797 42.8428 45.0579 43.0167L43.8405 41.5095C44.7681 40.3501 45.2318 38.9587 45.2318 37.5095C45.2318 35.7703 44.5362 34.1472 43.2608 32.9298L45.8695 28.3501C46.1014 28.408 46.3333 28.408 46.5652 28.408C48.9999 28.408 50.971 26.437 50.971 24.0022C50.971 21.5674 49.0579 19.5385 46.6231 19.5385C44.1883 19.5385 42.2173 21.5095 42.2173 23.9443C42.2173 24.9877 42.5652 25.9732 43.2608 26.7848L40.6521 31.3645C38.5652 30.7848 36.4782 31.2486 34.913 32.524L27.7246 27.1906C27.8405 26.7848 27.8985 26.379 27.8985 25.9153C27.8985 23.4805 25.9275 21.5095 23.4927 21.5095C21.0579 21.5095 19.0289 23.4805 19.0289 25.9153C19.0289 28.3501 20.9999 30.3211 23.4347 30.3211C24.3043 30.3211 25.1159 30.0892 25.8115 29.6254L32.9999 35.0167C32.6521 35.8283 32.4782 36.6399 32.4782 37.4515C32.4782 37.9153 32.5362 38.379 32.6521 38.9008L24.9999 43.0167C24.5362 42.8428 24.0144 42.7269 23.4347 42.7269C20.9999 42.7269 19.0289 44.6979 19.0289 47.1327C19.0289 49.5674 20.9999 51.5385 23.4347 51.5385C25.8695 51.5385 27.8405 49.5674 27.8405 47.1327C27.8405 46.495 27.6666 45.8573 27.4347 45.2196L34.1014 41.6254C35.3188 43.0167 37.0579 43.8283 38.855 43.8283C39.7246 43.8283 40.5362 43.6544 41.3478 43.3066L42.6811 44.9877C42.3333 45.6254 42.1014 46.379 42.1014 47.1327C42.1014 49.5674 44.0724 51.5385 46.5072 51.5385C48.942 51.5385 50.913 49.5674 50.913 47.1327C50.913 44.6979 49.0579 42.7269 46.6231 42.7269Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4461_1532"
        x1="35"
        y1="0.53846"
        x2="35"
        y2="70.5385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A42747" />
        <stop offset="1" stopColor="#8A213C" />
      </linearGradient>
    </defs>
  </svg>
)

export default ClustersSubcategory
